// „Bearbeiten (eigene Kopie)" und „Frei gestalten" (Spiegel von apps/core/src/contracts/template-edit.ts).
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { api } from './client';
import { qk } from './queries';
import type { LayoutRow } from './types';

export interface EditCopyResult { layout: LayoutRow; published: boolean; playlistId: string | null; itemId: string | null }

/** Eigene, frei gestaltbare Kopie einer Vorlage anlegen; mit playlistId/itemId wird die Folie samt Eingaben umgehängt. */
export function useEditCopy() {
  const qc = useQueryClient();
  return useCallback(async (layoutId: string, body: { name?: string; playlistId?: string; itemId?: string } = {}): Promise<EditCopyResult> => {
    const res = await api.post<EditCopyResult>(`/layouts/${layoutId}/edit-copy`, body);
    await Promise.all([
      qc.invalidateQueries({ queryKey: qk.layouts }),
      ...(body.playlistId ? [qc.invalidateQueries({ queryKey: qk.playlist(body.playlistId) }), qc.invalidateQueries({ queryKey: qk.playlists })] : []),
    ]);
    return res;
  }, [qc]);
}

/** Studio-Adresse der Kopie, mit Rücksprung. */
export const studioPath = (id: string, back?: string) => `/studio/${id}${back ? `?back=${encodeURIComponent(back)}` : ''}`;
